import { render, staticRenderFns } from "./RegularPriced.vue?vue&type=template&id=4ec5d523&scoped=true&"
import script from "./RegularPriced.vue?vue&type=script&lang=ts&"
export * from "./RegularPriced.vue?vue&type=script&lang=ts&"
import style0 from "./RegularPriced.vue?vue&type=style&index=0&id=4ec5d523&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec5d523",
  null
  
)

export default component.exports